import React, { useEffect } from "react";
import { isObject } from "underscore";
import useReduxState from "../../../../hooks/useReduxState";
import useBomRematchHook from "./BomRematchHook";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import Helper from "../../../../helper/Helper";
import { useBOMStore } from 'src/hooks/bom';

const BomRematchTable = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ bom_data_list, column_mapping_list, static_columns }, { }, { }] = useBOMStore();
    const [activateColumns, setActivateColumns] = useReduxState({}, 'setActivateColumns');
    const [ColumnsForFinish, setColumnsForFinish] = useReduxState({}, 'setColumnsForFinish');
    const [getDisplayStatusForFinishColumns] = useBomRematchHook();

    useEffect(() => {
        async function fetchHere() {
            if (Object.entries(activateColumns).length === 0) {
                activateColumns_columnName_all();
            }
        }

        fetchHere()
    }, [bom_data_list]);

    const activateColumns_columnName_all = () => {
        let a = { ...activateColumns };
        let c = { ...ColumnsForFinish };
        static_columns && isObject(static_columns) && column_mapping_list && isObject(column_mapping_list) &&
            Object.entries(column_mapping_list).map((v) => {
                let single_column_mapping_list = v[1];
                if (a[single_column_mapping_list.bomColumnName]) {
                    if (c[single_column_mapping_list.columnName]) {
                        delete c[single_column_mapping_list.columnName];
                    }
                    delete a[single_column_mapping_list.bomColumnName];
                } else {
                    a[single_column_mapping_list.bomColumnName] = single_column_mapping_list;
                }
            });
        setActivateColumns(a);
        setColumnsForFinish(c)
    };

    const set_activateColumns_columnName = (bomColumnName, single_column_mapping_list) => {
        let c = { ...ColumnsForFinish };
        if (bomColumnName === 'FORCE_DELETE' && c[single_column_mapping_list.columnName]) {
            delete c[single_column_mapping_list.columnName];
        } else {
            c[single_column_mapping_list.columnName] = {
                bomColumnName,
                columnName: single_column_mapping_list.columnName
            };
        }
        setColumnsForFinish(c)
    };

    const d = getDisplayStatusForFinishColumns();
    return (
        <>
            {__check(['BOM_REMATCH_API_CALL', 'BOM_REMATCH_SAVED_API_CALL', 'BOM_REMATCH_OPERATION_API_CALL']).render}
            {bom_data_list && isObject(bom_data_list) &&
                !__check(['BOM_REMATCH_OPERATION_API_CALL', 'BOM_REMATCH_SAVED_API_CALL', 'BOM_REMATCH_API_CALL']).status &&
                Object.entries(bom_data_list).length > 0 &&
                <div className="table-responsive border">
                    <table className="table table-bordered bs5 column-headers-table">
                        <thead>
                            <tr>
                                <th className='w35 text-center'>row</th>
                                {static_columns && isObject(static_columns) && column_mapping_list && isObject(column_mapping_list) &&
                                    Object.entries(column_mapping_list).map((v) => (
                                        <th key={Helper.UUID()}
                                            className={d.unique_column_selected_flag && !ColumnsForFinish[v[1].columnName] ? "th-error" : ''}>
                                            {activateColumns[v[1].bomColumnName] &&
                                                <div className="match-column-wrapper">
                                                    <div className="selectbox me-2 w-100">
                                                        <select onChange={(e) => {
                                                            set_activateColumns_columnName(e.target.value, v[1])
                                                        }} className="form-control form-control-sm me-3">
                                                            <option value={'FORCE_DELETE'}>Match Column Header</option>
                                                            {Object.entries(static_columns).map((v_static_columns) => (
                                                                <option
                                                                    value={v_static_columns[1].bomColumnName}
                                                                    selected={
                                                                        ColumnsForFinish[v[1].columnName] &&
                                                                            ColumnsForFinish[v[1].columnName].bomColumnName === v_static_columns[1].bomColumnName ? true : false}
                                                                >{v_static_columns[1].fileColumnName}</option>
                                                            ))
                                                            }
                                                        </select>
                                                    </div>
                                                    {d.unique_column_selected_flag &&
                                                        <>
                                                            {!ColumnsForFinish[v[1].columnName] &&
                                                                <i className="fa fa-exclamation-triangle" />
                                                            }
                                                            {ColumnsForFinish[v[1].columnName] && ColumnsForFinish[v[1].columnName].bomColumnName === 'part_number' &&
                                                                <>
                                                                    {d.part_number_flag &&
                                                                        <i className="fa fa-check-circle font-15 float-right text-darkgreen" />
                                                                    }
                                                                    {!d.part_number_flag &&
                                                                        <i className="fa fa-exclamation-triangle" />
                                                                    }
                                                                </>
                                                            }
                                                            {ColumnsForFinish[v[1].columnName] && ColumnsForFinish[v[1].columnName].bomColumnName !== 'part_number' &&
                                                                <i className="fa fa-check-circle font-15 float-right text-darkgreen" />
                                                            }
                                                        </>
                                                    }
                                                    {!d.unique_column_selected_flag &&
                                                        <i className="fa fa-exclamation-triangle" />
                                                    }
                                                </div>
                                            }
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {bom_data_list && isObject(bom_data_list) &&
                                bom_data_list[0] &&
                                <tr>
                                    <td className=' text-center'></td>
                                    {column_mapping_list && isObject(column_mapping_list) &&
                                        <>
                                            {Object.entries(column_mapping_list).map((v) => (
                                                <td>
                                                    {v[1].fileColumnName}
                                                </td>
                                            ))}
                                        </>
                                    }
                                </tr>
                            }
                            {bom_data_list && isObject(bom_data_list) &&
                                Object.entries(bom_data_list).map((v, i) => (
                                    <React.Fragment>
                                        <tr>
                                            <td>
                                                {v[1].row_counter_number}
                                            </td>
                                            <React.Fragment>
                                                {column_mapping_list && isObject(column_mapping_list) &&
                                                    Object.entries(column_mapping_list).map((v_column_mapping_list) => (
                                                        <React.Fragment>
                                                            <td>{v[1][v_column_mapping_list[1].columnName]}</td>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </React.Fragment>
                                        </tr>
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            }
        </>
    );
}

export default BomRematchTable;